<template>
	<div class="cart-show-list" ref="ref_cart_list"  :style="`height: ${height}px;`">
		<div v-if="good_list.length" class="scroll-view" scroll-y="true" :style="`height: ${height}px;`" :show-scrollbar="false">
			<cart-show-cell class="cart-show-cell"  v-for="good in good_list" :key="`cartshowcell-${good.id}`" :good="good"></cart-show-cell>
		</div>
	</div>
	
</template>

<script>
	import CartShowCell from "./cartshowcell.vue"
	export default {
		name:'cart-show-list',
		components:{
			CartShowCell,
		},
		props: {
			height:{
				type:Number,
				default:0
			},
			good_list: {
				type: Array,
				default: []
			}
		},
		
		data() {
			return {
				
			}
		},
		watch: {
			good_list(newValue, oldValue) {
				
			}
		},
		methods: {
			
			deletelike(good){
				this.$emit('deletelike',good)
			}
		},
		
	}
</script>

<style>
</style>